/*
 * Configures and enhance the VideoJS library
 */
import videojs from 'video.js';
import 'videojs-contrib-quality-levels';
import { BigPlayButton } from '../components/big_play_button';
import { ControlInteractions } from '../components/control_interactions';
import { SubsCapsButton } from '../components/subs_caps_button';

// Add extra option to the player for disabling the default
// handling of tech click
const Player = videojs.getComponent('Player');
const originalTechClick = Player.prototype.handleTechClick_;
Player.prototype.handleTechClick_ = function() {
  if (this.options_?.userActions?.click !== false) {
    return originalTechClick.apply(this, arguments);
  }
};

// Register our own components
// This needs to happen here so plugins extending VideoJS's components
// like videojs-vr does for the BigPlayButton end up overiding our own
// class rather than the native VideoJS ones which we already extend
videojs.registerComponent('BigPlayButton', BigPlayButton);
videojs.registerComponent('ControlInteractions', ControlInteractions);
videojs.registerComponent('SubsCapsButton', SubsCapsButton);

export default videojs;
